import DodonesDayShow from 'app/dodones/day/Show'
import DodonesGenericShow from 'app/dodones/generic/Show'
import DodonesBookShow from 'app/dodones/book/Show'
import DodonesBirlExerciseShow from 'app/dodones/birl_exercise/Show'
import DodonesMetronomeShow from 'app/dodones/metronome/Show'

import DodoneContext from 'app/dodones/Context'
import HeaderContext from 'app/HeaderContext'
import DodoneMenu from 'app/dodones/Menu'
import DodoneIgnoredBanner from 'app/dodones/shared/IgnoredBanner'
import DodoneProofTrigger from 'app/dodones/proofs/Trigger'

function resolveShowView(typeViewPrefix) {
  if (typeViewPrefix == 'Day') return DodonesDayShow
  if (typeViewPrefix == 'Book') return DodonesBookShow
  if (typeViewPrefix == 'BirlExercise') return DodonesBirlExerciseShow
  if (typeViewPrefix == 'Metronome') return DodonesMetronomeShow

  // if(typeViewPrefix == 'Generic')
  // if(typeViewPrefix == 'Birl')
  return DodonesGenericShow
}

export default () => {
  const dodoneContext = useContext(DodoneContext)
  const dodone = dodoneContext.dodone
  const { setContextualMenu, setBackPath } = useContext(HeaderContext)

  useEffect(() => {
    if (!dodone) {
      setContextualMenu(null)
      setBackPath(null)
      return
    }

    // Create menu component that captures the current dodone
    const DodoneSpecificMenu = (menuProps) => {
      return <DodoneMenu {...dodoneContext} {...menuProps} />
    }

    setContextualMenu(() => DodoneSpecificMenu)

    if (dodone.parentId) setBackPath(`/dodones/${dodone.parentId}`)
    else setBackPath(null)

    return () => {
      setContextualMenu(null)
      setBackPath(null)
    }
  }, [dodone, setContextualMenu])

  const DodonesSelectedShow = resolveShowView(dodone.typeViewPrefix)

  return (
    <>
      <DodoneProofTrigger dodone={dodone} showTextStatus={true} />
      <DodoneIgnoredBanner dodone={dodone} />
      <DodonesSelectedShow />
    </>
  )
}
